<template>
  <v-container>
    <Breadcrumbs :breadcrumbs="breadcrumbs" />
    <v-form ref="form" lazy-validation>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <v-row>
          <v-col cols="12" lg="6">
            <!-- book name  -->
            <v-text-field
              :rules="[rules.required]"
              v-model="bookDetails.bookname"
              class="mx-3"
              label="Book Name"
              outlined
              dense
            ></v-text-field>
            <!-- book dirve link  -->
            <v-text-field
              v-model="bookDetails.booklink"
              class="mx-3"
              label="Google Drive Link"
              outlined
              dense
            ></v-text-field>
            <!-- dicsription -->
            <v-textarea
              v-model="bookDetails.bookdsecription"
              class="mx-3"
              label="Book Dsecription"
              outlined
              rows="4"
              height="106"
              dense
            ></v-textarea>
            <v-img
              v-if="bookDetails.cover != null && !delete_cover"
              class="mx-3"
              :lazy-src="bookDetails.cover"
              max-width="200"
              :src="bookDetails.cover"
            >

            <v-btn @click="delete_cover = true && !delete_cover" style="position: absolute; top: 0; right: 0;" icon color="primary">
              <v-icon color="red">mdi-close-circle</v-icon></v-btn></v-img>
            <v-img
              v-else
              class="mx-3"
              lazy-src="../../assets/nobookcover.png"
              max-width="200"
              src="../../assets/nobookcover.png"
            ></v-img>
          </v-col>
          <v-col cols="12" lg="6">
            <!-- lang list -->
            <v-autocomplete
              :rules="[rules.required]"
              v-model="bookDetails.lang.langid"
              class="mx-3"
              :items="listLang"
              dense
              label="Lang"
              outlined
              item-text="langname"
              item-value="langid"
            ></v-autocomplete>
            <!-- category -->
            <v-autocomplete
              :rules="[rules.requiredArray]"
              v-model="bookDetails.categories"
              :items="bookDetails.categories"
              outlined
              dense
              :readonly="true"
              chips
              class="mx-3"
              small-chips
              label="Categories"
              multiple
              item-text="categoryname"
              item-value="categoryid"
              @focus="dialogCategoryTree = true"
            ></v-autocomplete>
            <!-- author  -->
            <v-autocomplete
              :rules="[rules.required]"
              :search-input.sync="authorNameSearch"
              v-model="bookDetails.author[0].authorid "
              class="mx-3"
              :items="listAuthors"
              dense
              label="Author Name"
              outlined
              item-text="authorname"
              item-value="authorid"
              @keyup="searchAuthor()"
              @keyup.ctrl.enter="addDialogAuthor = true"
            ></v-autocomplete>
            <!-- publisher  -->
            <v-autocomplete
              v-if="bookDetailsVersion.versionid != null"
              v-model="bookDetailsVersion.publisher[0]['publisherid']"
              :search-input.sync="publisherNameSearch"
              class="mx-3"
              :items="listPublishers"
              dense
              label="Publisher Name"
              outlined
              item-text="publishername"
              item-value="publisherid"
              @keyup="searchPublishers()"
              @keyup.ctrl.enter="addDialogPublisher = true"
            ></v-autocomplete>

            <v-text-field
              v-if="bookDetailsVersion.versionid != null"
              v-model="bookDetailsVersion.publisher[0]['publisheryear']"
              class="mx-3"
              label="Publisher Year"
              outlined
              dense
            ></v-text-field>

            <!-- image  -->
            <v-file-input
              class="mx-3"
              label="Book Cover"
              outlined
              prepend-icon="mdi-camera"
              dense
              @change="selectCover"
            ></v-file-input>
            <v-row>
              <v-col cols="12" lg="4">
                <v-switch
                  class="mx-3 pt-0 mt-0"
                  v-model="bookDetails.status"
                  label="Status"
                  color="primary"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" lg="4">
                <v-switch
                  class="mx-3 pt-0 mt-0"
                  v-model="bookDetails.isdownloadable"
                  label="Downloadable"
                  color="primary"
                  hide-details
                ></v-switch>
              </v-col>
              <v-col cols="12" lg="4">
                <v-switch
                  class="mx-3 pt-0 mt-0"
                  v-model="bookDetails.ispublish"
                  label="Published"
                  color="primary"
                  hide-details
                ></v-switch>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card
        elevation="3"
        style="border: 1px solid #e0e0e0"
        class="mb-6 pt-3 pb-3"
      >
        <v-row>
          <v-col cols="12">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 45%" class="text-left">Meta Name</th>
                    <th style="width: 45%" class="text-left">Meta Value</th>
                    <th style="width: 10%" class="text-left">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, index) in bookDetailsVersion.metainfo"
                    :key="index"
                  >
                    <td style="width: 45%" class="text-left">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            class="mt-6"
                            label="Meta Value"
                            :rules="[rules.required]"
                            v-model="item.meta_name"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </td>
                    <td style="width: 45%" class="text-left">
                      <v-text-field
                        class="mt-6"
                        label="Meta Value"
                        :rules="[rules.required]"
                        v-model="item.meta_value"
                        outlined
                        dense
                      >
                      </v-text-field>
                    </td>
                    <td style="width: 10%" class="text-left pb-4">
                      <span style="cursor: pointer" @click="removerMeta(index)"
                        ><i class="status fa fa-times-circle red--text"></i
                      ></span>
                    </td>
                  </tr>
                  <tr style="background-color: #ffff">
                    <td>
                      <v-btn
                        color="primary"
                        class="mt-3 ml-3"
                        @click="updateBookInfo()"
                        :loading="loadingUpdateBookInformation"
                      >
                        Save
                      </v-btn>
                    </td>
                    <td></td>
                    <td>
                      <v-btn
                        color="success"
                        @click="addMeta"
                        class="mt-3 ml-3 float-right"
                      >
                        Add Meta
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-card>
    </v-form>
    <SelectTreeCategory
      :dialogCategoryTree="dialogCategoryTree"
      v-on:closeCatDialog="DialogClose($event)"
      v-on:closeCatDialogWithCategories="
        closeCatDialogWithCategoriesMethod($event)
      "
    />
    <EditVersion
      v-if="ItemEdit != ''"
      :editVersions="EditVersion"
      :ItemEdit="ItemEdit"
      v-on:DialogClose="DialogClose($event)"
    />
    <DeleteVersion
      :deleteVersions="DeleteVersions"
      :ItemDelete="ItemDelete"
      v-on:DialogClose="DialogClose($event)"
    />
    <AddAuthor
      :addDialog="addDialogAuthor"
      v-on:DialogClose="DialogClose($event)"
    />
    <AddPublisher
      :addDialog="addDialogPublisher"
      v-on:DialogClose="DialogClose($event)"
    />
  </v-container>
</template>
<script>
import Breadcrumbs from "@/components/Global/Breadcrumbs";
import SelectTreeCategory from "@/components/Category/SelectTreeCategory";
import EditVersion from "@/components/Versions/EditVersion";
import DeleteVersion from "@/components/Versions/DeleteVersion";
import AddAuthor from "@/components/Authors/AddAuthor";
import AddPublisher from "@/components/Publishers/AddPublisher";
export default {
  data() {
    return {
      rules: {
        required: (value) => !!value || "Field required.",
        requiredArray: (value) => value != "" || "Field required.",
        maxvalue: (value) =>
          value.length <= 128 || "Maximum length is 128 characters",
        onlynumber: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0) || "Value Only Number",
      },
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Books",
          disabled: false,
          to: "/books",
        },

        {
          text: "Book Details",
          disabled: true,
        },
      ],
      headers: [
        { text: "#", value: "versionno" },
        { text: "Status", value: "status" },
        { text: "Created At", value: "created_at" },
        { text: "Action", value: "versionid" },
      ],
      delete_cover : false  ,
      loadingUpdateBookInformation: false,
      addDialogAuthor: false,
      addDialogPublisher: false,
      listLang: [],
      listAuthors: [],
      listPublishers: [],
      authorNameSearch: "",
      publisherNameSearch: "",
      dialogCategoryTree: false,
      coverBook: "",
      bookDetailsView: {
        lang: { langid: "" },
        author: [{ authorid: "" }],
      },
      bookDetails: {
        lang: { langid: "" },
        author: [{ authorid: "" }],
      },
      DeleteVersions: false,
      ItemDelete: "",
      EditVersion: false,
      ItemEdit: "",
      bookDetailsVersion: {
        publisher: [
          {
            publisherid: "",
          },
        ],
      },
    };
  },
  components: {
    Breadcrumbs,
    SelectTreeCategory,
    DeleteVersion,
    EditVersion,
    AddAuthor,
    AddPublisher,
  },
  mounted() {
    this.getBookDetails();
    this.getAllLang();
    this.getAllAuthors();
    this.getAllPublishers();
  },

  methods: {
    updateBookInfo() {
      if (this.$refs.form.validate() != false) {
        this.loadingUpdateBookInformation = true;
        let categorArray = [];
        for (
          let index = 0;
          index < this.bookDetails.categories.length;
          index++
        ) {
          categorArray.push(this.bookDetails.categories[index]["categoryid"]);
        }

        console.log(categorArray)

        const fd = new FormData();
        fd.append("bookname", this.bookDetails.bookname);
        fd.append("langid", this.bookDetails.lang.langid);
        fd.append("bookdsecription", this.bookDetails.bookdsecription || "");
        fd.append("booklink", this.bookDetails.booklink || "");
        fd.append("isdownloadable", this.bookDetails.isdownloadable ? 1 : 0);
        fd.append("author[0]", [this.bookDetails.author[0].authorid]);
        // fd.append("category", categorArray);
        for (let index = 0; index < categorArray.length; index++) {
          fd.append(`category[${index}]`, categorArray[index]);
          
        }
        fd.append("ispublish", this.bookDetails.ispublish ? 1 : 0);
        fd.append("status", this.bookDetails.status ? 1 : 0);
        
        fd.append("delete_cover", this.delete_cover ? 1 : 0);
        fd.append("_method", "PUT");
        if (this.coverBook != "") {
          fd.append("cover", this.coverBook);
        }
        let DataForm = {
          Param: fd,
          API: "/admin/book/" + this.bookDetails.bookid,
        };
        this.$store
          .dispatch("PostToAPI", DataForm)
          .then(() => {
            let DataFormMeta = {
              Param: {
                metainfo: this.bookDetailsVersion.metainfo,
              },
              API:
                "/admin/book/" +
                this.$route.params.bookID +
                "/version/" +
                this.bookDetails.version[0]["versionid"] +
                "/metainfo",
            };
            this.$store
              .dispatch("PutToAPI", DataFormMeta)
              .then(() => {})
              .catch((error) => {
                this.$store.dispatch("PushErrorMsg", error.data.message);
              });

            let DataFormVersion = {
              Param: {
                status: 1,
                isdefault: 1,
                publisher: {
                  publisherid: this.bookDetailsVersion.publisher[0][
                    "publisherid"
                  ],
                  year: this.bookDetailsVersion.publisher[0]["publisheryear"],
                },
              },
              API:
                "/admin/book/" +
                this.$route.params.bookID +
                "/version/" +
                this.bookDetails.version[0]["versionid"],
            };
            this.$store
              .dispatch("PutToAPI", DataFormVersion)
              .then(() => {})
              .catch((error) => {
                let errorObj = error.data.data;
                this.loadingStepOne = false;
                this.$store.dispatch(
                  "PushErrorMsg",
                  errorObj[Object.keys(errorObj)[0]][0]
                );
              });
            this.loadingUpdateBookInformation = false;
            // this.getBookDetails();
            this.$router.push({ name: "Books" })
            this.$store.dispatch("PushSuccessMsg", "Updated Book Success ");
          })
          .catch((error) => {
            let errorObj = error.data.data;
            this.loadingUpdateBookInformation = false;
            this.$store.dispatch(
              "PushErrorMsg",
              errorObj[Object.keys(errorObj)[0]][0]
            );
          });
      } else {
        this.$store.dispatch("PushErrorMsg", "Data Not Valid");
      }
    },
    getBookDetails() {
      this.$store
        .dispatch("GetFromAPI", "/admin/book/" + this.$route.params.bookID)
        .then((response) => {
          this.bookDetails = response.data.data;
          // this.bookDetails.cover == null
          //   ? (this.bookDetails.cover = "../../assets/nobookcover.png")
          //   : "";

          console.log(this.bookDetails);
          //@/assets/nobookcover.png
          this.getBookDetailsVersion();
        });
    },
    getBookDetailsVersion() {
      this.bookDetailsVersion = {};
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/book/" +
            this.$route.params.bookID +
            "/version/" +
            this.bookDetails.version[0]["versionid"]
        )
        .then((response) => {
          this.bookDetailsVersion = response.data.data;
          if(this.bookDetails.author[0]){
            console.log('h h h h')
            this.listAuthors.push({
              authorid: this.bookDetails["author"][0]["authorid"],
              authorname: this.bookDetails["author"][0]["authorname"],
            });
          }else{
            // this.bookDetails.author[0]
            console.log('h h  5 2 h h')
            this.bookDetails["author"].push({'authorid' : 8 , 'authorname' : 'Unknown' })
          }
        });
    },
    getAllLang() {
      this.$store.dispatch("GetFromAPI", "/admin/lang").then((response) => {
        this.listLang = response["data"]["data"];
      });
    },
    getAllAuthors() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/author?per_page=20&filter[authorname]=" +
            this.authorNameSearch
        )
        .then((response) => {
          this.listAuthors = response["data"]["data"];
        });
    },
    searchAuthor() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllAuthors();
      }
    },
    getAllPublishers() {
      this.$store
        .dispatch(
          "GetFromAPI",
          "/admin/publisher?per_page=20&filter[publishername]=" +
            this.publisherNameSearch
        )
        .then((response) => {
          this.listPublishers = response["data"]["data"];
        });
    },
    searchPublishers() {
      if (event.keyCode != 40 && event.keyCode != 38 && event.keyCode != 13) {
        this.getAllPublishers();
      }
    },
    DialogClose(val) {
      if (val == true) {
        this.getBookDetails();
      }
      this.dialogCategoryTree = false;
      this.DeleteVersions = false;
      this.EditVersion = false;
      this.ItemEdit = "";
      this.addDialogAuthor = false;
      this.addDialogPublisher = false;
    },
    selectCover(file) {
      this.coverBook = file;
    },
    closeCatDialogWithCategoriesMethod(vals) {
      this.dialogCategoryTree = false;
      this.bookDetails.categories = vals;
    },
    editItem(item) {
      this.EditVersion = true;
      this.ItemEdit = item;
    },
    deleteItem(item) {
      this.ItemDelete = item;
      this.DeleteVersions = true;
    },
    removerMeta(index) {
      this.bookDetailsVersion.metainfo.splice(index, 1);
    },
    addMeta() {
      this.bookDetailsVersion.metainfo.push({ name: "", value: "" });
    },
  },
};
</script>